<template>
    <div class="paragrafo">
        <div class="titolo" @click="triggerAperto"> 
            <div>
                <slot name="titolo"></slot>
            </div>
        </div>
        <div class="testo" :class="{'aperto':aperto}" > 
            <div>
                <slot name="contenuto"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'paragrafo',
    data() {
        return {
            aperto: false,
        }
    }, 
    methods: { 
        triggerAperto() {
            this.aperto = !this.aperto;
        }
    }
}
</script>

<style scoped>

.titolo{
    font-weight: bold;
}
.titolo:hover{ 
    cursor: pointer;
    text-decoration: underline;
}
.testo{ 
    transition-duration: 1s;
    overflow: auto;
    height: 0;
    /* transform:scaleX(-1); */
}
.testo.aperto {  
    height: auto;
}
.testo > div {
    
    margin-right: 20px;
    padding-left:20px;
    /* transform: scaleX(-1); */
}
</style>